module.exports = __webpack_public_path__ + "img/2.154631e7.jpg";